/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Language_LabelInputs */

const en_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language selection`)
};

const fr_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection de la langue`)
};

const de_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachauswahl`)
};

const it_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione della lingua`)
};

const ru_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор языка`)
};

const es_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de idioma`)
};

const zh_cn2_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言选择`)
};

const ja_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語の選択`)
};

const hi_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा चयन`)
};

const pt_pt2_spellcheck_language_label = /** @type {(inputs: Spellcheck_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de idioma`)
};

/**
* | output |
* | --- |
* | "Language selection" |
*
* @param {Spellcheck_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_language_label = /** @type {((inputs?: Spellcheck_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_language_label(inputs)
	if (locale === "de") return de_spellcheck_language_label(inputs)
	if (locale === "it") return it_spellcheck_language_label(inputs)
	if (locale === "ru") return ru_spellcheck_language_label(inputs)
	if (locale === "es") return es_spellcheck_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_language_label(inputs)
	if (locale === "ja") return ja_spellcheck_language_label(inputs)
	if (locale === "hi") return hi_spellcheck_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_language_label(inputs)
	return en_spellcheck_language_label(inputs)
});